import { startCase } from 'es-toolkit';
import { FunctionComponent } from 'react';
import { connect } from 'react-redux';

import { formatDegrees } from '@paragon/client-tools';
import { JackGirderConnection } from '@paragon/contract-library';

import { RootState } from '../../../../../store';
import { getDistanceFormatterSelector } from '../../../../../store/selectors/getDistanceFormatterSelector';
import { getNaturalSortedComponentDesigns } from '../../../../../store/selectors/getSortedComponentDesignsSelectors';
import { useAppSelector } from '../../../../hooks';
import { DisplayNameProviderProps } from './PrimaryRowText';

type OwnProps = DisplayNameProviderProps<JackGirderConnection>;
type StateProps = ReturnType<typeof mapStateToProps>;

const CarriedComponentName: FunctionComponent<OwnProps & StateProps> = (props) => {
  const girderLoad = props.row.item;

  const distanceFormatter = useAppSelector(getDistanceFormatterSelector);

  // The parentheses around the location and angle are so that the dashes aren't mistaken for minus signs
  const componentName = props.jackComponentName ?? 'unknown component';
  const location = `${distanceFormatter(girderLoad.xLocation)}`;
  const memberType = startCase(girderLoad.memberType);
  const numberOfJacks = girderLoad.numberOfJacks === 1 ? '' : ` | ${girderLoad.numberOfJacks} components`;
  const angle = `${formatDegrees(girderLoad.minimumAngleBetweenGirderAndJack)}`;

  // @ts-expect-error https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/53846
  return `${componentName} | ${location} | ${memberType}${numberOfJacks} | ${angle}${girderLoad.userCreated ? ' | *' : ''}` as ReactElement;
};

const mapStateToProps = (state: RootState, props: OwnProps) => {
  const componentDesigns = getNaturalSortedComponentDesigns(state);
  const jackComponentDesign = componentDesigns.find(
    (componentDesign) => componentDesign.guid === props.row.item.jackGuid,
  );

  return {
    jackComponentName: jackComponentDesign ? jackComponentDesign.component.name : null,
  };
};

export default connect(mapStateToProps)(CarriedComponentName);
